exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-btn {\n  display: inline-block;\n  background-color: #bfad37;\n  color: #eae8e8;\n  border-radius: 5px;\n  border: none;\n  padding: 10px 20px;\n  width: 70px;\n}\n\n@media screen and (max-width: 580px) {\n  input {\n    width: 100px;\n    font-size: 10px;\n  }\n\n  .save-btn  {\n    font-size: 12px;\n    width: 40px;\n    padding: 0px;\n  }\n}\n\n@media screen and (max-width: 375px) {\n  input {\n    width: 80px;\n    font-size: 8px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/save-beat/save-beat.component.css
// module id = ../../../../../src/app/save-beat/save-beat.component.css
// module chunks = main